/* istanbul ignore file */
import { EnumField, useFieldHelper, FieldProps } from 'framework/ui/field';
import { OPPORTUNITY_STAGES } from 'domain/sales/opportunity/opportunityService';

const OpportunityStageField = ({ value: inputValue = null, source = null, label = null }: FieldProps) => {
  const { getValue } = useFieldHelper({ value: inputValue, source });

  const value = inputValue || (getValue && getValue());

  return <EnumField label={label} value={value} options={OPPORTUNITY_STAGES} />;
};

export default OpportunityStageField;
